import { Pencil, TrashBin } from '@gravity-ui/icons'
import { Button, Table, Tooltip } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import type { Vehicle } from '@/types/vehicle.types'

interface VehicleTableRowProps {
  vehicle: Vehicle;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export function VehicleTableRow({ vehicle: v, onEdit, onDelete }: VehicleTableRowProps) {
  const { t } = useTranslation()
  const driverName = v.driver?.fullName || '—'


  return (
    <Table.Row key={v.id} className="cursor-pointer">
      <Table.Cell onClick={() => onEdit(v.id)}>
        <span className="font-black">{v.plate}</span>
      </Table.Cell>
      <Table.Cell onClick={() => onEdit(v.id)}>{v.brand}</Table.Cell>
      <Table.Cell onClick={() => onEdit(v.id)} className="">{v.year}</Table.Cell>
      <Table.Cell onClick={() => onEdit(v.id)}>
        <div className="flex flex-col">
          <span className="font-bold text-zinc-800 dark:text-zinc-200">{driverName}</span>
          {v.driver?.phone && (
            <span className="text-xs text-zinc-500">{v.driver.phone}</span>
          )}
        </div>
      </Table.Cell>

      <Table.Cell onClick={() => onEdit(v.id)}>
        <div className="flex justify-end gap-2">
          <Tooltip delay={0}>
            <Button isIconOnly size="sm" variant="tertiary" onClick={e => {
              e.stopPropagation()
              onEdit(v.id)
            }}
            >
              <Pencil className="size-4" />
            </Button>
            <Tooltip.Content>
              <p>{t('common.edit')}</p>
            </Tooltip.Content>
          </Tooltip>

          <Tooltip delay={0}>
            <Button isIconOnly size="sm" variant="danger-soft" onClick={e => {
              e.stopPropagation()
              onDelete(v.id)
            }}
            >
              <TrashBin className="size-4" />
            </Button>
            <Tooltip.Content>
              <p>{t('common.delete')}</p>
            </Tooltip.Content>
          </Tooltip>
        </div>
      </Table.Cell>
    </Table.Row>
  )
}
